module.exports = __webpack_public_path__ + "img/020026.f9450510.png";